import {L} from "./util.js";
function getcodecpayloadtype(sdplines, codec) {
 var index = findline(sdplines, 'a=rtpmap', codec);
 return index ? getcodecpayloadtypefromline(sdplines[index]) : null;
}

function getcodecpayloadtypefromline(sdpLine) {
 var pattern = new RegExp('a=rtpmap:(\\d+) \\w+\\/\\d+');
 var result = sdpLine.match(pattern);
 return (result && result.length === 2) ? result[1] : null;
}

function preferbitrate(sdp, bitrate, mediatype) {
 var sdplines = sdp.split('\r\n');
 
 // Find m line for the given mediatype.
 var ml_index = findline(sdplines, 'm=', mediatype);
 if (ml_index === null) {
  L.trace('Failed to add bandwidth line to sdp, as no m-line found');
  return sdp;
 }

 // Find next m-line if any.
 var next_ml_index = findlineinrange(sdplines, ml_index + 1, -1, 'm=');
 if (next_ml_index === null) {
  next_ml_index = sdplines.length;
 }

 // Find c-line corresponding to the m-line.
 var cl_index = findlineinrange(sdplines, ml_index + 1, next_ml_index, 'c=');
 if (cl_index===null) {
  L.trace('Failed to add bandwidth line to sdp, as no c-line found');
  return sdp;
 }

 // check if bandwidth line already exists between c-line and next m-line.
 var bLineIndex=findlineinrange(sdplines, cl_index + 1, next_ml_index, 'b=AS');
 if (bLineIndex){
   sdplines.splice(bLineIndex, 1);
 }

 // create the b (bandwidth) sdp line.
 var bwLine = 'b=AS:' + bitrate;
 // As per RFC 4566, the b line should follow after c-line.
 sdplines.splice(cl_index + 1, 0, bwLine);
 sdp = sdplines.join('\r\n');
 return sdp;
}

function prefercodec(sdp, type, dir, codec) {
 /** The format of |codec| is 'NAME/RATE'('opus/48000') */
 var str = type + ' ' + dir + ' codec';
 if (!codec) {
  L.trace('No preference on ' + str + '.');
  return sdp;
 }

 L.trace('Prefer ' + str + ': ' + codec);

 var sdplines = sdp.split('\r\n');
 var ml_index = findline(sdplines, 'm=', type);
 if (ml_index === null){
  L.Error(`No Mline index`);
  return sdp;
 }
 var payload = getcodecpayloadtype(sdplines, codec);
 L.info(payload);
 //L.info(sdplines[ml_index]);
 if (payload)
  sdplines[ml_index] = setdefaultcodec(sdplines[ml_index], payload);
 //console.log(sdplines);
 sdp = sdplines.join('\r\n');
 return sdp;
}

function setcodecparam(sdp, codec, param, value) {
 var sdplines = sdp.split('\r\n');

 var fmtpline_index = findfmtpline(sdplines, codec);

 var fmtpObj = {};
 if (fmtpline_index === null) {
   var index = findline(sdplines, 'a=rtpmap', codec);
   if (index === null) {
     return sdp;
   }
   var payload = getcodecpayloadtypefromline(sdplines[index]);
   fmtpObj.pt = payload.toString();
   fmtpObj.params = {};
   fmtpObj.params[param] = value;
   sdplines.splice(index + 1, 0, writefmtpline(fmtpObj));
 } else {
   fmtpObj = parsefmtpline(sdplines[fmtpline_index]);
   fmtpObj.params[param] = value;
   sdplines[fmtpline_index] = writefmtpline(fmtpObj);
 }

 sdp = sdplines.join('\r\n');
 return sdp;
}

// Remove fmtp param if it exists.
function removecodecparam(sdp, codec, param) {
 var sdplines = sdp.split('\r\n');

 var fmtpline_index = findfmtpline(sdplines, codec);
 if (fmtpline_index === null) {
   return sdp;
 }

 var map = parsefmtpline(sdplines[fmtpline_index]);
 delete map.params[param];

 var newLine = writefmtpline(map);
 if (newLine === null) {
   sdplines.splice(fmtpline_index, 1);
 } else {
   sdplines[fmtpline_index] = newLine;
 }

 sdp = sdplines.join('\r\n');
 return sdp;
}

// Split an fmtp line into an object including 'pt' and 'params'.
function parsefmtpline(fmtpLine) {
 var fmtpObj = {};
 var spacePos = fmtpLine.indexOf(' ');
 var keyValues = fmtpLine.substring(spacePos + 1).split('; ');

 var pattern = new RegExp('a=fmtp:(\\d+)');
 var result = fmtpLine.match(pattern);
 if (result && result.length === 2)
  fmtpObj.pt = result[1];
 else
  return null;

 var params = {};
 for (var i = 0; i < keyValues.length; ++i) {
  var pair = keyValues[i].split('=');
  if (pair.length === 2)
   params[pair[0]] = pair[1];
 }
 fmtpObj.params = params;
 return fmtpObj;
}

// Generate an fmtp line from an object including 'pt' and 'params'.
function writefmtpline(fmtpObj) {
 if (fmtpObj.pt===undefined || fmtpObj.params===undefined)
  return null;
 var pt = fmtpObj.pt;
 var params = fmtpObj.params;
 var keyValues = [];
 var i = 0;
 for (var key in params) {
  keyValues[i] = key + '=' + params[key];
  ++i;
 }
 if (i === 0) {
  return null;
 }
 return 'a=fmtp:' + pt.toString() + ' ' + keyValues.join('; ');
}

// Find fmtp attribute for |codec| in |sdplines|.
function findfmtpline(sdplines, codec) {
 // Find payload of codec.
 var payload = getcodecpayloadtype(sdplines, codec);
 // Find the payload in fmtp line.
 return payload ? findline(sdplines, 'a=fmtp:' + payload.toString()) : null;
}

// Find the line in sdplines that starts with |prefix|, and, if specified,
// contains |substr| (case-insensitive search).
function findline(sdplines, prefix, substr) {
 return findlineinrange(sdplines, 0, -1, prefix, substr);
}

// Find the line in sdplines[startLine...endLine - 1] that starts with |prefix|
// and, if specified, contains |substr| (case-insensitive search).
function findlineinrange(sdplines, startLine, endLine, prefix, substr) {
 var realEndLine = endLine !== -1 ? endLine : sdplines.length;
 for (var i = startLine; i < realEndLine; ++i) {
  if (sdplines[i].indexOf(prefix) === 0) {
   if(!substr ||sdplines[i].toLowerCase().indexOf(substr.toLowerCase()) !== -1) {
     return i;
   }
  }
 }
 return null;
}

// Returns a new m= line with the specified codec as the first one.
function setdefaultcodec(mLine, payload) {
 var elements = mLine.split(' ');

 // Just copy the first three parameters; codec order starts on fourth.
 var newLine = elements.slice(0, 3);

 // Put target payload first and copy in the rest.
 newLine.push(payload);
 for (var i = 3; i < elements.length; i++) {
   if (elements[i] !== payload) {
     newLine.push(elements[i]);
   }
 }
 return newLine.join(' ');
}
/*function merge_constraints(cons1, cons2) {
 if (!cons1 || !cons2) {
  return cons1 || cons2;
 }
 var merged = cons1;
 for (var key in cons2) {
  merged[key] = cons2[key];
 }
 return merged;
}

function icecandidatetype(candidateStr) {
  return candidateStr.split(' ')[7];
}

function formattypepreference(pref) {
 if (webrtcDetectedBrowser === 'chrome') {
  switch (pref) {
   case 0:
    return 'TURN/TLS';
   case 1:
    return 'TURN/TCP';
   case 2:
    return 'TURN/UDP';
  }
 } else if (webrtcDetectedBrowser === 'firefox') {
  switch (pref) {
   case 0:
    return 'TURN/TCP';
   case 5:
    return 'TURN/UDP';
  }
 }
 return '';
}*/

export const SDP={
 set_opus_options: function(sdp, params){
  if (params.opusStereo === 'true') {
   sdp = setcodecparam(sdp, 'opus/48000', 'stereo', '1');
  } else if (params.opusStereo === 'false') {
   sdp = removecodecparam(sdp, 'opus/48000', 'stereo');
  }
 
  if (params.opusFec === 'true') {
   sdp = setcodecparam(sdp, 'opus/48000', 'useinbandfec', '1');
  } else if (params.opusFec === 'false') {
   sdp = removecodecparam(sdp, 'opus/48000', 'useinbandfec');
  }
 
  if (params.opusDtx === 'true') {
   sdp = setcodecparam(sdp, 'opus/48000', 'usedtx', '1');
  } else if (params.opusDtx === 'false') {
   sdp = removecodecparam(sdp, 'opus/48000', 'usedtx');
  }
 
  if(params.opusMaxPbr) {
   sdp = setcodecparam(sdp, 'opus/48000', 'maxplaybackrate', params.opusMaxPbr);
  }
  return sdp;
 },
 set_audio_send_bitrate: function(sdp, params){
  if (!params.audiosendbitrate) {
   return sdp;
  }
  L.trace('Prefer audio send bitrate: ' + params.audiosendbitrate);
  return preferbitrate(sdp, params.audiosendbitrate, 'audio');
 },
 set_audio_receive_bitrate: function(sdp, params){
  if (!params.audiorecvbitrate) {
   return sdp;
  }
  L.trace('Prefer audio receive bitrate: ' + params.audiorecvbitrate);
  return preferbitrate(sdp, params.audiorecvbitrate, 'audio');
 },
 set_video_send_bitrate: function(sdp, params){
  if (!params.videosendbitrate) {
   return sdp;
  }
  L.trace('Prefer video send bitrate: ' + params.videosendbitrate);
  return preferbitrate(sdp, params.videosendbitrate, 'video');
 },
 set_video_receive_bitrate: function(sdp, params){
  if (!params.videorecvitrate) {
   return sdp;
  }
  L.trace('Prefer video receive bitrate: ' + params.videorecvitrate);
  return preferbitrate(sdp, params.videorecvitrate, 'video');
 },
 prefer_audio_send_codec: function(sdp, params){
  return prefercodec(sdp, 'audio', 'send', params.audiosendcodec);
 },
 prefer_audio_receive_codec: function(sdp, params) {
  return prefercodec(sdp, 'audio', 'receive', params.audiorecvcodec);
 },
 prefer_video_send_codec: function(sdp, params) {
  return prefercodec(sdp, 'video', 'send', params.videosendcodec);
 },
 prefer_video_receive_codec: function(sdp, params) {
   return prefercodec(sdp, 'video', 'receive', params.videorecvcodec);
 },
 set_video_send_initial_bitrate: function(sdp, params){
  var ini_bitrate = params.video_send_initial_bitrate;
  if (!ini_bitrate)
   return sdp;
  
  // Validate the initial bitrate value.
  var maxbitrate = ini_bitrate;
  var bitrate = params.videosendbitrate;
  if (bitrate) {
   if (ini_bitrate > bitrate) {
    L.trace('Clamping initial bitrate to max bitrate of ' + bitrate + ' kbps.');
    ini_bitrate = bitrate;
    params.video_send_initial_bitrate = ini_bitrate;
   }
   maxbitrate = bitrate;
  }
 
  var sdplines = sdp.split('\r\n');
 
  // Search for m line.
  var ml_index = findline(sdplines, 'm=', 'video');
  if (ml_index === null) {
   L.trace('Failed to find video m-line');
   return sdp;
  }
 
  sdp = setcodecparam(sdp, 'VP8/90000', 'x-google-min-bitrate', params.video_send_initial_bitrate.toString());
  sdp = setcodecparam(sdp, 'VP8/90000', 'x-google-max-bitrate', maxbitrate.toString());
  return sdp;
 }
};
